import { render, staticRenderFns } from "./Dis.vue?vue&type=template&id=d342e9c4"
import script from "./Dis.vue?vue&type=script&lang=js"
export * from "./Dis.vue?vue&type=script&lang=js"
import style0 from "./Dis.vue?vue&type=style&index=0&id=d342e9c4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports